import { render, staticRenderFns } from "./AssessmentThankYouPage.vue?vue&type=template&id=d467a82a"
import script from "./AssessmentThankYouPage.vue?vue&type=script&lang=js"
export * from "./AssessmentThankYouPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports